module.exports = __webpack_public_path__ + "img/IMG_1645_L_BlackMatted_MockedUp.872a38be.jpg";